module.exports = __webpack_public_path__ + "static/media/patternAutumn.6279698f.png";